import { axios } from "utils";

import { ADMIN_PAYMENTS_URL as endpoint } from "consts";

import { PaymentItem } from "models";

export const getAllPayments = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}`, { data, signal: data.signal });

export const getAllPendingPayments = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/pending`, { data, signal: data.signal });

export const generateCreditNoteAdmin = async (data: { token: string; signal: AbortSignal }) =>
  axios.get(`${endpoint}/credit-notes/${data.token}`, { data, signal: data.signal });

export const getPaymentItems = async (data: {
  farmId?: string;
  vesting?: boolean;
  paid?: boolean;
  fieldModuleIds: string[];
  signal: AbortSignal;
}): Promise<PaymentItem[]> => axios.get(`${endpoint}/payment-items`, { data, signal: data.signal });

export const processPayments = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}`, { data, signal: data.signal });

export const getAllReferralPayments = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/referrals`, { data, signal: data.signal });

export const generateReferralWalletList = async (data: { signal: AbortSignal }) =>
  axios.get(`${endpoint}/referrals/wallets`, { data, responseType: "blob", signal: data.signal });

export const processReferralPayments = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/referrals`, { data, signal: data.signal });
